import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import CaseStudy5StarResortIndiaRevenueOptimization from "../pages/CaseStudy5StarResortIndiaRevenueOptimization/CaseStudy5StarResortIndiaRevenueOptimization";
import "../index.css";
import "../pages/CaseStudy5StarResortIndiaRevenueOptimization/CaseStudy5StarResortIndiaRevenueOptimization.module.css";

type AnyProps = Record<string, any>;

let root:
| ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;


        function App(props: AnyProps) {
        const { router = "memory", basename, initialEntries, ...pageProps } = props;

        if (router === "memory") {
        return (
        <MemoryRouter initialEntries={initialEntries ?? ["/"]}>
        <CaseStudy5StarResortIndiaRevenueOptimization {...(pageProps as any)} />
        </MemoryRouter>
        );
        }

        return (
        <BrowserRouter basename={basename}>
            <CaseStudy5StarResortIndiaRevenueOptimization {...(pageProps as any)} />
        </BrowserRouter>
        );
        }

        function mount(el: HTMLElement, props: AnyProps = {}) {
        console.log("Rendering......")
        root = createRoot(el);
        root.render(<App {...props} />);
        }

        function hydrate(el: HTMLElement, props: AnyProps = {}) {
        console.log("Hydrating......")

        root = hydrateRoot(el, <App {...props} />);
        }

        function unmount() {
        root?.unmount?.();
        root = null;
        }

        if (typeof window !== "undefined")
        (window as any).CaseStudy5StarResortIndiaRevenueOptimizationVC = { mount, hydrate, unmount };